import React from 'react';
import Iconfont from '@base/lib/Iconfont';
import Image from '@base/lib/ThemeImage';
import { IconPoints } from '@pro/common/IconPoints';

const DownAppContent: React.FC = () => {
    return (
        <>
            <Image
                width={330}
                height={19}
                src={'asset/width-660/picture/20236c9846df57385d8535907c4b0cb2.png'}
                background={false}
            />
            <div className="grid-main">
                <div className="grid-get">Download to receive</div>
                <div className="grid-off">15% Off</div>
                <div className="grid-tip">App Exclusive</div>
                <div className="grid-code text-center">
                    <span>Code: </span>APPSHOP
                </div>
                <div className="grid-qr flex flex-middle flex-justify">
                    <Image
                        src="asset/width-224/picture/9a0a8196cc1b3f68ac9e325496c6ea11.png"
                        width={112}
                        fixed
                        background={false}
                    />
                    <div>
                        <Iconfont className="icon-Android"/>
                        <Iconfont className="icon-iphone"/>
                    </div>
                </div>
            </div>
            <div className={'text-right'}>
                <IconPoints className={'brand-icon'} type={false} size={68}/>
            </div>
        </>
    );
};

export default DownAppContent;
